<template>
  <dropdown
    class="settings"
    :visible="visible"
    :animation="animation"
    :position="position"
    @clickout="visible=false">
    <button
      class="link"
      @click="visible=true">
      <div
        class="settings__icon">
        <font-awesome-icon
          :icon="icon.cog" />
      </div>
      <div
        class="trigger">
        <font-awesome-icon
          :icon="icon.angleDown" />
      </div>
    </button>
    <slot
      name="settings"
      slot="dropdown">
    </slot>
  </dropdown>
</template>

<script>
import {eventBus} from '@/main';
import dropdown from 'vue-my-dropdown';
import FontAwesomeIcon from '@fortawesome/vue-fontawesome';
import faCog from '@fortawesome/fontawesome-free-solid/faCog';
import faSave from '@fortawesome/fontawesome-free-solid/faSave';
import faAngleDown from '@fortawesome/fontawesome-free-solid/faAngleDown';
import IconArrowRight from '@/components/shared/icons/IconArrowRight';
import faDownload from '@fortawesome/fontawesome-free-solid/faDownload';
import faCopy from '@fortawesome/fontawesome-free-solid/faCopy';

export default {
  components: {
    FontAwesomeIcon,
    dropdown,
    IconArrowRight
  },
  data () {
    return {
      visible: false,
      position: ['right', 'bottom', 'right', 'top'],
      animation: 'ani-fade',
      visibleNested: false,
      positionNested: ['left', 'top', 'right', 'top'],
      icon: {
        cog: faCog,
        angleDown: faAngleDown,
        download: faDownload,
        copy: faCopy,
        save: faSave
      }
    };
  },
  created () {
    eventBus.$on('closeSettings', this.hide);
  },
  destroyed () {
    eventBus.$off('closeSettings', this.hide);
  },
  methods: {
    hide () {
      this.visible = false;
    }
  }
};
</script>

<style lang="scss" scoped>
@import "../../../stylesheets/variables.scss";

.settings {
  margin-left: auto;
  .link {
    display: flex;
    align-items: center;
    background-color: transparent;
    border: 0;
    color: inherit;
    &:hover,
    &:focus {
      opacity: 0.75;
      cursor: pointer;
      outline: 0;
    }
  }
  &__icon {
    color: $white-trans4;
    margin-right: $sp;
  }
  .trigger svg {
    transform: scale(0.875);
    transform-origin: bottom;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/shared/topbar/TopbarSettings.vue